export default function (state) {
  return [
    {
      type: 'index',
      name: '№',
      prop: 'index',
      slot: 'index',
      resize: false,
      fixed: true,
      visible: true,
      width: 75,
      label: '№',
      index: 0,
      id: 'index' + 0,
    },
    ...state.columns.filter(i => {
      return i.visible || (i.name === 'DocNumber') || (i.name === 'Acc');
    }),
  ];
}